/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI76142ResDataItemChildListItem {
  
  /** 任务id */
  bizNo?: string;
  
  /** 任务内容 */
  taskTitle?: string;
  
  /** 任务状态 */
  taskStatus?: string;
  
  /** 是否正常 */
  isNormal?: string;
  
  /** 截止时间 */
  endTime?: string;
  
  /** 是否需要提交交付物 */
  completeTaskNeedSubmit?: number;
  
};
    
  
    
export interface IAPI76142ResDataItem {
  
  /** 任务id */
  bizNo?: string;
  
  /** task */
  taskTitle?: string;
  
  /** 任务id */
  endTime?: string;
  
  /** 子任务信息列表 ,TaskInstanceChildInfoResp */
  childList?: IAPI76142ResDataItemChildListItem[];
  
};
    
  



export interface API76142Req {
  
  /**  */
  userId?: string;
    
  /** 1-进行中2-已完成 */
  isFinished?: string;
    
  /** 1-代办2-发起 */
  isCreate?: string;
    
};



export type API76142Res = IAPI76142ResDataItem[];


// 接口函数 76142 任务实例列表按状态分组

export interface IUseGetAPI76142Return {
  /** 任务实例列表按状态分组: 接口请求状态 */
  isAPI76142Loading: boolean;
  /** 任务实例列表按状态分组: 接口请求返回数据 */
  dataAPI76142: API76142Res;
  /**  任务实例列表按状态分组: 接口数据请求方法 */
  fetchAPI76142Data: (inputs: API76142Req, config?: YWRequestConfig) => Promise<API76142Res>;
  /** 任务实例列表按状态分组: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76142 = ():IUseGetAPI76142Return => {
  let isMount = true;
  const [isAPI76142Loading, setIsAPI76142Loading] = useState(false);
  const [dataAPI76142, setDataAPI76142] = useState<API76142Res>({} as API76142Res);
  const requestUrl = `${basePath}/yoaichat-web/task/instance/list/status`;

  const fetchAPI76142Data = async (inputs: API76142Req, config?: YWRequestConfig): Promise<API76142Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76142Req>) || {}) as API76142Req;
    
  
    if ( isMount ) {
      setIsAPI76142Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API76142Res>(`${basePath}/yoaichat-web/task/instance/list/status?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI76142(res || {} as API76142Res);
        setIsAPI76142Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76142Loading(false);
      }
      return false as unknown as API76142Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76142Loading,
    dataAPI76142,
    fetchAPI76142Data,
    requestUrl,
  }
}

